export const RESET_POST_TYPE_FILTER = 'RESET_POST_TYPE_FILTER';

export const resetPostTypeFilter = () => ({
  type: RESET_POST_TYPE_FILTER,
});
